import React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import questions from './questions_data/questions';
import MobileStepper from '@mui/material/MobileStepper';

const steps = [
  'Personal Particulars',
  'Fitness',
  'Skincare',
  'Lifestyle',
  'Nutrition',
  'Additional Information'
];

export default function VerticalLinearStepper({ currentQuestion }) {
  let activeStep = 0;

  if (currentQuestion > 10) {
    activeStep = 1
  }
  if (currentQuestion > 20) {
    activeStep = 2
  }
  if (currentQuestion > 26) {
    activeStep = 3
  }
  if (currentQuestion > 35) {
    activeStep = 4
  }
  if (currentQuestion > 43) {
    activeStep = 5
  }
  if (currentQuestion > 51) {
    activeStep = 6
  }

  return (
    <div>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((step) => (
            <Step key={step}>
              <StepLabel>
                {step}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Box sx={{ display: { xs: 'block', sm: 'none' } }}> 
        <MobileStepper
          variant="progress"
          steps={questions.length}
          position="static"
          activeStep={currentQuestion}
          sx={{ flexGrow: 1 }}
        />
      </Box>
    </div>

  )
}
